import { useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../context/index";
import { TransactionalSubheader } from "iuvity-ui-components/dist/transactionalsubheader";
import { BoxFull } from "iuvity-ui-components/dist/boxfull";
import { TabView } from "iuvity-ui-components/dist/tabview";
import { FormSkeleton, Header } from "../../components";
import { ProtocolsAdminComponent } from "../../components/catalogue/ProtocolsAdminComponent";

export const AdminCataloguePage = () => {
    const navigate = useNavigate();
    const {
        t,
        appState: { user, language, activeIndexCatalogue, pageFilter },
        setAppState,
    } = useContext(AppContext);

    const [activeIndex, setActiveIndex] = useState<number>(activeIndexCatalogue || 0);

    return (
        <>
            {/* <Header
                welcomeMessage={t("Dashboard.welcomeTitle")}
                userName={user?.name}
            /> */}
            <TransactionalSubheader
                subheaderTitle={
                <div
                    style={{
                    position: "relative",
                    left: "-3rem",
                    }}
                >
                    <span style={{ color: "var(--cardBackgroundColorOneShade80)" }}>{t("Catalogue.catalogueTitle")}</span>
                </div>
                }
            >
                <TransactionalSubheader.BreadCrumb
                id={t("Catalogue.catalogueTitle")}
                disabledDefaultHome={true}
                breadcrumbsHomeItem={{
                    icon: "iu iu-icon-home",
                    command: () => navigate("/"),
                }}
                breadcrumbsItems={[
                    {
                        label: t("Catalogue.consoleManagementBreadcrumbs"),
                        style: { fontWeight: "bold" },
                        disabled: true
                    },
                    {
                        label: t("Catalogue.rolesManagementBreadcrumbs"),
                        style: { fontWeight: "bold" },
                        disabled: true
                    },
                    {
                        label: t("Catalogue.catalogueTitle"),
                        style: { fontFamily: "var(--fontBarlowSemiBold)" },
                        disabled: true
                    },
                ]}
                />
                <TransactionalSubheader.Title />
            </TransactionalSubheader>

            <BoxFull className="my-4 px-0 py-0" variant="tertiary">
                <TabView
                    className="upload-tabview mt-4"
                    activeIndex={activeIndex}
                    onTabChange={(e) => {
                        setActiveIndex(e.index);
                        setAppState((prev) => ({
                            ...prev,
                            activeIndexPoints: e.index,
                        }));
                    }}
                    items={[
                        {
                            key: "1",
                            header: t("Catalogue.protocolsTabTitle"),
                            children: <ProtocolsAdminComponent />,
                            disabled: false,
                        },
                        {
                            key: "2",
                            header: t("Catalogue.methodsTabTitle"),
                            children: <></>,
                        },
                        {
                            key: "3",
                            header: t("Catalogue.categoriesTabTitle"),
                            children: <></>,
                            disabled: false,
                        },
                        {
                            key: "4",
                            header: t("Catalogue.roletypesTabTitle"),
                            children: <></>,
                            disabled: false,
                        },
                        {
                            key: "5",
                            header: t("Catalogue.statusTabTitle"),
                            children: <></>,
                            disabled: false,
                        },
                        {
                            key: "6",
                            header: t("Catalogue.actionsTabTitle"),
                            children: <></>,
                            disabled: false,
                        },
                    ]}
                />
            </BoxFull>
            {/* <CustomDialog
                title={modalProps.title}
                visible={modalProps.visible}
                content={modalProps.content}
                handleModalState={setModalProps}
                onConfirm={modalProps.onConfirm}
            /> */}
        </>
    )
}